import { TestId } from "../testIdType"

export const testId: TestId = {
    addType: "add-type",
    article: "article",
    articleHeader: "article-header",
    articleImportFile: "article-import-file",
    articlePublishInfo: "article-publish-info",
    articleStatus: "article-status",
    articleToolbar: "article-toolbar",
    cancelButton: "cancelButton",
    category: "category",
    categoryTitle: "category-title",
    categoryTitleLink: "category-title-link",
    categoryToggleIcon: "category-toggle-icon",
    clearSearchArticlesInput: "clear-search-articles-input",
    currentBranchParentIcon: "current-branch-parent-icon",
    currentBranchParentLink: "current-branch-parent-link",
    defaultPublish: "defaultPublish",
    delayedPublish: "delayedPublish",
    favoriteArticle: "favorite-article",
    importFilesKB: "import-files-kb",
    publishButton: "publishButton",
    publishDate: "publishDate",
    saveNewsline: "save-newsline-settings-btn",
    searchArticlesButton: "search-articles-button",
    searchArticlesInput: "search-articles-input",
    searchQueryArticle: "search-query-article",
    searchQueryArticleLink: "search-query-article-link",
    subArticleItem: "sub-article-item",
    subArticleItemLink: "sub-article-item-link",
    unpublishDate: "unpublishDate",
    catalogsLoader: "catalogs-loader",
    similarQuestionsContainer: "similar-questions-container",
    similarQuestionsInput: "similar-questions-input",
    similarQuestionsCheckbox: "similar-questions-checkbox"
}
